export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adjuntos de exportación"])},
          "no_attachments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No hay adjuntos"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exportation Attachments"])},
          "no_attachments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No attachments"])}
        }
      }
    }
  })
}